// Input types that don't represent free text entry (e.g. checkboxes, buttons).
const NON_TEXT_INPUT_TYPES = new Set([
  "BUTTON",
  "CHECKBOX",
  "COLOR",
  "FILE",
  "HIDDEN",
  "IMAGE",
  "RADIO",
  "RANGE",
  "RESET",
  "SUBMIT",
]);

/**
 * True when the focused element is editable text (input, textarea, contenteditable
 * or ARIA textbox). Used to ignore global shortcuts (copy/paste, undo/redo, ...)
 * while the user is typing (e.g. label features, plan names, number inputs etc.).
 */
const isTextInputFocused = () => {
  const el = document.activeElement as HTMLElement | null;
  if (!el) {
    return false;
  }

  if (el.tagName === "TEXTAREA") {
    return true;
  }

  if (el.tagName === "INPUT") {
    const type = (el as HTMLInputElement).type?.toUpperCase();
    return !NON_TEXT_INPUT_TYPES.has(type);
  }

  if (el.isContentEditable) {
    return true;
  }

  return el.getAttribute("role")?.toUpperCase() === "TEXTBOX";
};

export default isTextInputFocused;
